export const hotArticles = [
  {
    id: '1',
    title: '某顶流艺人深夜密会神秘女子 酒店共度8小时全程被拍',
    summary: '据知情人士透露，该艺人近期正处于新剧宣传期，此次密会事件或将对品牌代言产生重大影响。',
    category: '热门大瓜',
    categorySlug: 'remen-dagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Celebrity%20paparazzi%20night%20scene%20luxury%20hotel%20entrance%20mysterious%20silhouette%20dramatic%20lighting%20warm%20amber%20tones%20cinematic%20mood%20editorial%20photography%20soft%20shadows%20high%20contrast%20elegant%20composition%20nighttime%20atmosphere&width=800&height=600&seq=hot-article-01&orientation=landscape',
    publishedAt: '2026-06-28T14:30:00',
    views: 1280000,
    comments: 5600,
    isHot: true,
    isNew: true,
  },
  {
    id: '2',
    title: '知名企业家被曝财务造假 涉案金额高达50亿 官方已介入调查',
    summary: '多家权威媒体联合报道，该企业财报存在重大疑点，监管部门已成立专案组展开深入调查。',
    category: '黑料曝光',
    categorySlug: 'expose',
    imageUrl: 'https://readdy.ai/api/search-image?query=Corporate%20scandal%20investigation%20office%20documents%20scattered%20on%20desk%20dramatic%20moody%20lighting%20warm%20dark%20tones%20financial%20crime%20theme%20editorial%20style%20high%20detail%20professional%20photography%20serious%20atmosphere&width=800&height=600&seq=hot-article-02&orientation=landscape',
    publishedAt: '2026-06-28T10:00:00',
    views: 960000,
    comments: 4300,
    isHot: true,
    isNew: false,
  },
  {
    id: '3',
    title: '网红情侣分手内幕曝光：第三者插足、财产纠纷、互爆猛料',
    summary: '曾经甜蜜的百万粉丝情侣档突然宣布分手，双方在社交平台隔空互撕，爆出大量惊人内幕。',
    category: '热门大瓜',
    categorySlug: 'remen-dagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Couple%20argument%20dramatic%20breakup%20scene%20split%20screen%20composition%20warm%20cinematic%20lighting%20emotional%20tension%20modern%20apartment%20setting%20soft%20warm%20tones%20editorial%20photography%20high%20detail&width=800&height=600&seq=hot-article-03&orientation=landscape',
    publishedAt: '2026-06-27T22:00:00',
    views: 850000,
    comments: 6200,
    isHot: false,
    isNew: true,
  },
  {
    id: '4',
    title: '某平台头部主播偷税漏税被罚2.8亿 直播间已被永久封禁',
    summary: '税务部门公布最新稽查结果，该主播通过隐匿个人收入、虚假申报等方式偷逃税款，已被依法处理。',
    category: '吃瓜事件',
    categorySlug: 'event',
    imageUrl: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20empty%20dark%20abandoned%20equipment%20ring%20light%20off%20dramatic%20moody%20atmosphere%20warm%20amber%20accents%20editorial%20style%20professional%20photography%20high%20contrast%20cinematic%20composition&width=800&height=600&seq=hot-article-04&orientation=landscape',
    publishedAt: '2026-06-27T16:00:00',
    views: 2100000,
    comments: 8900,
    isHot: true,
    isNew: false,
  },
  {
    id: '5',
    title: '选秀节目黑幕录音曝光 导师暗示选手"懂得都懂"引发轩然大波',
    summary: '一段疑似选秀节目后台录音在网络疯传，录音中某导师对选手说出意味深长的话语，节目组紧急回应。',
    category: '吃瓜大赛',
    categorySlug: 'competition',
    imageUrl: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20behind%20scenes%20dramatic%20spotlight%20shadowy%20figures%20mysterious%20atmosphere%20warm%20stage%20lighting%20cinematic%20mood%20theatrical%20composition%20editorial%20photography%20high%20detail%20professional&width=800&height=600&seq=hot-article-05&orientation=landscape',
    publishedAt: '2026-06-26T20:00:00',
    views: 750000,
    comments: 5100,
    isHot: false,
    isNew: false,
  },
  {
    id: '6',
    title: '某女星与前经纪公司解约官司胜诉 获赔3000万并恢复自由身',
    summary: '历经两年诉讼，该女星终于赢得解约官司，法院认定经纪公司存在多项违约行为。',
    category: '吃瓜事件',
    categorySlug: 'event',
    imageUrl: 'https://readdy.ai/api/search-image?query=Celebrity%20victory%20moment%20outside%20courthouse%20confident%20pose%20warm%20sunlight%20professional%20attire%20elegant%20composition%20editorial%20style%20soft%20natural%20light%20high%20detail%20cinematic%20photography&width=800&height=600&seq=hot-article-06&orientation=landscape',
    publishedAt: '2026-06-26T12:00:00',
    views: 620000,
    comments: 3400,
    isHot: false,
    isNew: false,
  },
];

export const categoryEntries = [
  {
    slug: 'remen-dagua',
    name: '热门大瓜',
    icon: 'ri-fire-line',
    description: '全网最火爆的吃瓜事件汇总',
    imageUrl: 'https://readdy.ai/api/search-image?query=Breaking%20news%20headlines%20dramatic%20red%20accents%20newsroom%20atmosphere%20urgent%20vibe%20warm%20tones%20bold%20typography%20editorial%20design%20professional%20photography%20high%20detail%20clean%20composition&width=600&height=400&seq=category-hot&orientation=landscape',
    count: 128,
  },
  {
    slug: 'expose',
    name: '黑料曝光',
    icon: 'ri-spy-line',
    description: '独家黑料深度揭秘',
    imageUrl: 'https://readdy.ai/api/search-image?query=Investigative%20journalism%20detective%20board%20with%20red%20strings%20connecting%20photos%20dramatic%20moody%20lighting%20warm%20tones%20mysterious%20atmosphere%20noir%20style%20cinematic%20composition%20editorial%20photography&width=600&height=400&seq=category-expose&orientation=landscape',
    count: 86,
  },
  {
    slug: 'competition',
    name: '吃瓜大赛',
    icon: 'ri-trophy-line',
    description: '每日吃瓜大赛精彩对决',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20competition%20spotlight%20stage%20trophy%20golden%20accents%20warm%20theatrical%20lighting%20elegant%20design%20celebration%20atmosphere%20editorial%20photography%20high%20detail%20professional%20clean%20composition&width=600&height=400&seq=category-competition&orientation=landscape',
    count: 56,
  },
];

export const latestUpdates = [
  {
    id: 'u1',
    title: '51在线最新入口已更新 吃瓜群众速来围观',
    tag: '51在线',
    time: '2分钟前',
    categorySlug: '51online',
  },
  {
    id: 'u2',
    title: '某知名品牌代言人突然宣布解约 背后原因成谜',
    tag: '吃瓜事件',
    time: '15分钟前',
    categorySlug: 'event',
  },
  {
    id: 'u3',
    title: '网红圈再爆大瓜：知名博主被实名举报学术造假',
    tag: '黑料曝光',
    time: '28分钟前',
    categorySlug: 'expose',
  },
  {
    id: 'u4',
    title: '今日吃瓜大赛第三轮投票开启 谁能问鼎瓜王',
    tag: '吃瓜大赛',
    time: '45分钟前',
    categorySlug: 'competition',
  },
  {
    id: 'u5',
    title: '某综艺节目录制现场发生意外 节目组紧急回应',
    tag: '热门大瓜',
    time: '1小时前',
    categorySlug: 'remen-dagua',
  },
  {
    id: 'u6',
    title: '51吃瓜入口今日更新 新增独家爆料专栏',
    tag: '51在线',
    time: '1小时前',
    categorySlug: '51online',
  },
  {
    id: 'u7',
    title: '娱乐圈某夫妻被曝已分居半年 双方工作室保持沉默',
    tag: '热门大瓜',
    time: '2小时前',
    categorySlug: 'remen-dagua',
  },
  {
    id: 'u8',
    title: '知名电竞选手涉嫌假赛被联盟终身禁赛',
    tag: '吃瓜事件',
    time: '3小时前',
    categorySlug: 'event',
  },
];

export const competitionEntries = [
  {
    id: 'c1',
    title: '本周瓜王争霸赛',
    subtitle: 'TOP10热门事件终极对决',
    participants: 15280,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20versus%20battle%20stage%20two%20sides%20facing%20off%20warm%20golden%20spotlight%20theatrical%20atmosphere%20competition%20theme%20editorial%20photography%20high%20detail%20cinematic%20composition%20professional%20clean%20design&width=800&height=500&seq=competition-01&orientation=landscape',
  },
  {
    id: 'c2',
    title: '黑料真假鉴定局',
    subtitle: '专业团队深度验证',
    participants: 8930,
    imageUrl: 'https://readdy.ai/api/search-image?query=Detective%20investigation%20magnifying%20glass%20over%20documents%20warm%20dark%20lighting%20mysterious%20atmosphere%20truth%20seeking%20theme%20editorial%20style%20high%20detail%20professional%20photography%20noir%20composition&width=800&height=500&seq=competition-02&orientation=landscape',
  },
  {
    id: 'c3',
    title: '51在线资源PK',
    subtitle: '最全资源入口大比拼',
    participants: 12450,
    imageUrl: 'https://readdy.ai/api/search-image?query=Digital%20data%20battle%20arena%20futuristic%20interface%20warm%20amber%20accents%20competition%20theme%20modern%20design%20editorial%20style%20professional%20photography%20high%20detail%20clean%20cinematic%20composition&width=800&height=500&seq=competition-03&orientation=landscape',
  },
];

export const testimonials = [
  {
    id: 't1',
    name: '吃瓜小能手',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%20casual%20style%20friendly%20expression%20warm%20lighting%20minimal%20background%20clean%20studio%20photography&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '自从发现了今日吃瓜，我再也不用到处刷微博刷豆瓣了！所有热门事件一站式搞定，每天打开看看就知道今天发生了什么，真的是吃瓜群众的福音！',
    rating: 5,
  },
  {
    id: 't2',
    name: '资深瓜农',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Stylish%20Chinese%20woman%20portrait%20confident%20expression%20warm%20lighting%20clean%20studio%20background%20professional%20photography&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '黑料曝光区太给力了！很多独家内容在其他平台根本看不到，更新速度也特别快。51在线入口也很方便，资源整理得很齐全。',
    rating: 5,
  },
  {
    id: 't3',
    name: '吃瓜路人甲',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20relaxed%20smile%20casual%20outfit%20warm%20lighting%20clean%20studio%20background%20professional%20headshot&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '每日吃瓜大赛真的太上头了！每天投票选出最劲爆的瓜，还能看到实时排行榜。评论区也很有意思，大家都是段子手。',
    rating: 4,
  },
  {
    id: 't4',
    name: '爆料一线',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Trendy%20Chinese%20woman%20portrait%20fashionable%20style%20warm%20smile%20clean%20studio%20background%20professional%20photography%20soft%20lighting&width=100&height=100&seq=avatar-04&orientation=squarish',
    content: '作为经常冲在第一线的吃瓜人，我负责任地说今日吃瓜是目前信息最全、更新最快的吃瓜平台。结构化分类也很清晰，找瓜特别方便！',
    rating: 5,
  },
  {
    id: 't5',
    name: '夜猫吃瓜',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20night%20owl%20vibe%20casual%20hoodie%20warm%20lighting%20clean%20studio%20background%20professional%20headshot&width=100&height=100&seq=avatar-05&orientation=squarish',
    content: '深夜吃瓜必备！经常半夜还能刷到最新爆料，这更新速度真的没谁了。51在线资源也是深夜党福音。',
    rating: 4,
  },
  {
    id: 't6',
    name: '理性吃瓜人',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20elegant%20style%20warm%20lighting%20clean%20studio%20background%20professional%20photography%20soft%20expression&width=100&height=100&seq=avatar-06&orientation=squarish',
    content: '很喜欢吃瓜大赛的"真假鉴定"环节，不会盲目跟风，有专业人士分析事件真伪。理性吃瓜才是好瓜民！推荐给大家。',
    rating: 5,
  },
];
